import { Toaster as SonnerToaster } from "sonner";

function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily: "var(--font-display)",
        },
        classNames: {
          toast:
            "bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-lg shadow-[var(--shadow-lg)] text-[hsl(var(--foreground))]",
          title: "font-semibold text-sm",
          description: "text-[0.8125rem] text-[hsl(var(--muted-foreground))]",
          success: "[&_svg]:text-[var(--success)]",
          error: "[&_svg]:text-[var(--error)]",
          warning: "[&_svg]:text-[var(--warning)]",
          info: "[&_svg]:text-[var(--info)]",
        },
      }}
    />
  );
}

export { Toaster };
